<script>
  import type { IFolderData } from "../FolderStructure.svelte";
  import { t } from "../../../../../core";

  export let folderData: IFolderData;
  export let isSearchActive: boolean;
  export let getFolder: (folderId?: number | null) => void;
  export let handleBack: () => void;
</script>

<div class="folder-breadcrumbs">
  <div class="folder-breadcrumbs__back">
    {#if folderData?.id !== null && !isSearchActive}
      <button on:click={handleBack}>
        <svg class="icon" width="15" height="16" aria-label="back">
          <use xlink:href="#arrow-left" />
        </svg>
      </button>
    {/if}
  </div>
  <div class="folder-breadcrumbs__list">
    {#if isSearchActive}
      <span>{t("Page.DocLib.Breadcrumbs.SearchResults")}</span>
    {:else}
       {#each folderData?.breadcrumbs || [] as breadcrumb}
         {#if breadcrumb.isDisabled}
           <span>/{breadcrumb.name}</span>
         {:else}
           <span>/</span><button
             class="link"
             on:click={() => getFolder(breadcrumb.folderId)}
             >{breadcrumb.name}</button
           >{/if}
       {/each}
    {/if}
  </div>
</div>

<style lang="scss">
  .folder-breadcrumbs {
    padding: 0 10px 20px;
    display: flex;
    align-items: center;

    &__back {
      display: flex;
      align-items: center;
      margin-right: 10px;

      @include sm {
        flex: 0 0 100px;
        margin-right: 0;
      }
    }
  }

  .icon {
    fill: $key-color;
  }
</style>
